import { Link } from "react-router-dom";
import timg1 from "../../images/teams/img-1.jpg";
import timg2 from "../../images/teams/img-2.jpg";
import timg3 from "../../images/teams/img-3.jpg";
import timg4 from "../../images/teams/img-4.jpg";

interface BrideGroomItem {
  id: string;
  tImg: string;
  name: string;
  title: string;
  animation: string;
}

interface BrideGroomsProps {
  brClass?: string;
}

const Brides: BrideGroomItem[] = [
  {
    id: "1",
    tImg: timg1,
    name: "Jenny Wilson",
    title: "Bridesmaid",
    animation: "1000",
  },
  {
    id: "2",
    tImg: timg2,
    name: "Robert Fox",
    title: "Groomsmen",
    animation: "1200",
  },
  {
    id: "3",
    tImg: timg3,
    name: "Annette Black",
    title: "Bridesmaid",
    animation: "1400",
  },
  {
    id: "4",
    tImg: timg4,
    name: "Jenefer Abram",
    title: "Groomsmen",
    animation: "1600",
  },
];

const BrideGrooms: React.FC<BrideGroomsProps> = ({ brClass }) => {
  return (
    <section className={`wpo-team-section ${brClass || ""}`}>
      <div className="container">
        <div className="wpo-team-wrap">
          <div className="wpo-section-title">
            <h2 className="poort-text poort-in-right">Special Guests</h2>
            <p>
              From intimate gatherings to grand luxury weddings, we bring
              together creativity, organization, and passion to design every
              detail with precision.
            </p>
          </div>

          <div className="row">
            {Brides.map((bride) => (
              <div
                className="col-lg-3 col-md-6 col-sm-6 col-12"
                key={bride.id}
              >
                <div
                  className="wpo-team-item wow fadeInUp"
                  data-wow-duration={`${bride.animation}ms`}
                >
                  <div className="team-img-wrap">
                    <div className="wpo-team-img">
                      <img src={bride.tImg} alt={bride.name} />
                    </div>
                  </div>
                  <div className="wpo-team-text">
                    <h3>
                      <Link to="/groom-bride">{bride.name}</Link>
                    </h3>
                    <span>{bride.title}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrideGrooms;
